<template>
  <div class="app-container">
    <div class="controls">
      <h2>二维码图像合成 & 批量打印</h2>

      <div class="input-group">
        <label>选择产品（将显示在第一行）：</label>
        <select v-model="selectedProductName" class="template-select">
          <option v-for="t in spList" :key="t.id" :value="t.name">
            {{ t.name }}
          </option>
        </select>
      </div>

      <div class="input-group">
        <label>输入编号 (bh)，每行一个：</label>
        <textarea
            v-model="inputText"
            placeholder="例如：22800101070364000843"
            rows="5"
        ></textarea>
      </div>

      <div class="actions">
        <button @click="startProcess" :disabled="isProcessing" class="btn-primary">
          {{ isProcessing ? '处理中...' : '开始合成二维码' }}
        </button>
        <button v-if="resultImages.length > 0" @click="printAll" class="btn-success">
          直接打印全部
        </button>
      </div>
    </div>

    <div class="preview-area" v-if="resultImages.length > 0">
      <h3>合成预览 ({{ resultImages.length }} 张)</h3>
      <div class="grid">
        <div v-for="(img, index) in resultImages" :key="index" class="card">
          <img :src="img" />
          <span class="code-text">{{ barcodeList[index] }}</span>
        </div>
      </div>
    </div>

    <div style="display: none;">
      <canvas ref="canvasRef"></canvas>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
  name: 'QRCodeComposite',

  data() {
    return {
      // 基础跳转链接
      baseUrl: "https://crm.deecoo.com/Gh.html?bh=",
      bgUrl: "/traceable.png", // 对应 public/traceable.png
      inputText: "",
      barcodeList: [],
      resultImages: [],
      isProcessing: false,
      selectedProductName: "",
      spList: []
    };
  },

  mounted() {
    this.getproct();
  },

  methods: {
    getproct() {
      this.$request.postHttp({
        url: "/basic/getsp",
        success: (data) => {
          this.spList = data.data;
          if(this.spList.length > 0) {
            this.selectedProductName = this.spList[0].name; // 默认选中第一个
          }
        },
        error: (error) => {
          console.error("Error:", error);
        },
      })
    },

    preloadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    },

    // 单张合成：产品名 + bh + 二维码

    async composite(bh, bgImg) {
      const fullUrl = this.baseUrl + bh;
      const qrSize = 500;

      const qrDataUrl = await QRCode.toDataURL(fullUrl, {
        errorCorrectionLevel: 'H',
        margin: 1,
        width: qrSize,
        color: { dark: '#000000', light: '#ffffff' }
      });

      return new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const qrImg = new Image();

        qrImg.onload = () => {
          canvas.width = bgImg.width;
          canvas.height = bgImg.height;
          ctx.drawImage(bgImg, 0, 0);

          ctx.textAlign = "center";
          ctx.fillStyle = "#000000";

          // --- 第一行：产品名 ---
          const maxWidth = 600;
          let fontSize = 60;
          ctx.font = `bold ${fontSize}px Arial`;

          while (ctx.measureText(this.selectedProductName).width > maxWidth && fontSize > 20) {
            fontSize -= 2;
            ctx.font = `bold ${fontSize}px Arial`;
          }
          ctx.font = `bold ${fontSize}px Arial`;
          ctx.fillText(this.selectedProductName, 1000, 148);


          const maxWidth1 = 600;
          let fontSize1 = 60;
          ctx.font = `bold ${fontSize1}px Arial`;

          while (ctx.measureText(bh).width > maxWidth1 && fontSize1 > 20) {
            fontSize1 -= 2;
            ctx.font = `bold ${fontSize1}px Arial`;
          }
          ctx.font = `bold ${fontSize1}px Arial`;
          ctx.fillText(bh, 1000, 297);
          // --- 二维码 (第三行) ---
          const qrX = (canvas.width - qrSize) / 2;
          const qrY = 380;

          ctx.fillStyle = "white";
          ctx.fillRect(qrX - 5, qrY - 5, qrSize + 10, qrSize + 10);
          ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize);

          resolve(canvas.toDataURL('image/png'));
        };
        qrImg.src = qrDataUrl;
      });
    },

    async startProcess() {
      if (this.inputText.trim() === "") return this.$message.warning("请输入编号");
      if (!this.selectedProductName) return this.$message.warning("请选择产品");

      this.isProcessing = true;
      this.resultImages = [];
      this.barcodeList = this.inputText.split('\n').map(v => v.trim()).filter(v => v);

      try {
        const bgImg = await this.preloadImage(this.bgUrl);
        const results = [];
        for (const bh of this.barcodeList) {
          const res = await this.composite(bh, bgImg);
          results.push(res);
        }
        this.resultImages = results;
      } catch (err) {
        alert("生成失败，请确认 public 目录下是否存在 traceable.png");
        console.error(err);
      } finally {
        this.isProcessing = false;
      }
    },

    printAll() {
      const printWindow = window.open('', '_blank');
      let htmlContent = `<html><head><style>
        @page { size: auto; margin: 5mm; }
        body { margin: 0; text-align: center; -webkit-print-color-adjust: exact !important; }
        .print-item { width: 80mm; display: inline-block; margin: 5mm; page-break-after: always; }
      </style></head><body>`;

      this.resultImages.forEach(src => {
        htmlContent += `<img src="${src}" class="print-item" />`;
      });

      htmlContent += `</body></html>`;
      printWindow.document.write(htmlContent);
      printWindow.document.close();
      printWindow.onload = () => {
        setTimeout(() => { printWindow.print(); }, 1000);
      };
    }
  }
};
</script>

<style scoped>
.app-container { font-family: sans-serif; max-width: 900px; margin: 0 auto; padding: 20px; }
.controls { background: #f4f7f6; padding: 20px; border-radius: 8px; margin-bottom: 30px; }
.template-select { width: 100%; padding: 10px; margin-bottom: 15px; border: 1px solid #ddd; border-radius: 4px; }
textarea { width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box; }
.actions { margin-top: 15px; display: flex; gap: 10px; }
button { padding: 10px 20px; border: none; border-radius: 4px; cursor: pointer; font-weight: bold; }
.btn-primary { background: #4a90e2; color: white; }
.btn-success { background: #52c41a; color: white; }
.grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); gap: 15px; margin-top: 20px; }
.card { border: 1px solid #eee; padding: 10px; text-align: center; background: #fff; }
.card img { width: 100%; border-radius: 4px; }
.code-text { font-size: 12px; color: #666; display: block; margin-top: 5px; word-break: break-all; }
</style>